module.exports = __webpack_public_path__ + "static/media/01_design_pao-mobil-azur.860fda27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_pao-mobil-azur.jpg
// module id = 239
// module chunks = 0